import { DatePipe } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray, FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Chart, ChartDataset, ChartOptions } from 'chart.js';
import { interval, Subscription } from 'rxjs';
import { AppSettingService } from 'src/app/services/app-setting.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { FilterBayService } from 'src/app/services/filter-bay.service';
import { ForecastingService } from 'src/app/services/forecasting.service';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { switchMap, takeWhile } from 'rxjs/operators';
import { forecastHeader } from 'src/app/properties/forecasting_header';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

@Component({
  selector: 'app-forecasting-woodenstreet-form-molecule',
  templateUrl: './forecasting-woodenstreet-form-molecule.component.html',
  styleUrls: ['./forecasting-woodenstreet-form-molecule.component.scss']
})
export class ForecastingWoodenstreetFormMoleculeComponent {
  @Input() formData;
  @ViewChild('inputField') inputField: ElementRef<HTMLInputElement>;
  @Input() categoryL1;
  @Input() scenarioDate: string;
  @Output() scenarioUpdated = new EventEmitter<string>();
  @Output() dataEmitForPOPUPOUTER = new EventEmitter<{}>();
  gridData: any
  dynamicHeaders: any;
  formGroup: FormGroup;
  isEditable: boolean = false;
  name: FormControl = new FormControl('', [Validators.required, Validators.minLength(3)]);
  active: FormControl = new FormControl('');
  overAllMarketingSpend: FormControl = new FormControl(0, [Validators.required,  Validators.min(0)]);
  overAllMacroEconomicCondition: FormControl = new FormControl({value: 0,disabled: !this.isEditable}, [Validators.required, Validators.minLength(1)]);
  duration: FormControl = new FormControl({ value: 3, disabled: !this.isEditable }, [Validators.required, Validators.minLength(1)]);
  net_sales: FormControl = new FormControl({ value: false, disabled: !this.isEditable });
  categoryPrevisionList: FormArray;
  userAddedCat: boolean = false;
  displayProjectionResult: boolean = true;
  timeoutId: any;
  intervalId: any;
  isCreateNewScenario: boolean
  statuses: string[] = [
    "Data Cleansing",
    "Feature Engineering",
    "Model Evaluation",
    "Running Predictions",
    "Completed",
  ];
  isEditing: boolean = false;
  private subscription: Subscription;
  showLastStep: boolean = true;
  isExpanded: boolean = true;
  panelOpenState = [true, false, false];
  // Could be in the possible states NEW|DEFINED|PREDICTED|APPROVED|DEMAND_APPLIED
  canPredict: boolean = false;
  canApprove: boolean = false;
  forecastStepState: boolean[] = [false, false, false];
  predictStepIndex: number = -1;
  showCategoryPrecisions = false;
  public lineChartData: ChartDataset<'line'>[] = [];
  public lineChartLabels: string[] = [];

  public lineChartOptions: ChartOptions<'line'> = {
    responsive: true,
    scales: {
      x: {},
      y: {
        beginAtZero: true
      }
    }
  };
  public lineChartLegend = true;
  public lineChartType = 'line';
  categoryLevel1Values: string[] = [];
  selectedFilter: string = '';
  chart: any;
  showFilterOptions = false;
  isDiscount: boolean = true;
  analyticsType: any
  forecastSetting: any;
  generalPropertiesTemplate: any[];
  externalInputsTemplate: any[];

  constructor(private fb: FormBuilder, private forecastingService: ForecastingService, private filterBayService: FilterBayService, private dialog: MatDialog,
    private snack: MatSnackBar, private authService: AuthenticationService, private datePipe: DatePipe, private settingService: AppSettingService) { }

  ngOnInit(): void {
    const forecastSettings = this.settingService?.getSettings()?.forecast;
    this.generalPropertiesTemplate = forecastSettings?.general_properties;
    this.externalInputsTemplate = forecastSettings?.external_inputs;
    if (this.formData) {
      this.name.setValue(this.formData?.name || '');
      this.active.setValue((this.formData?.active || this.scenarioDate) || false);
      this.overAllMarketingSpend.setValue(this.formData?.overAllMarketingSpend || 0);
      this.overAllMacroEconomicCondition.setValue(this.formData?.overAllMacroEconomicCondition || 0);
      this.net_sales.setValue(this.formData?.netSales || false);
      this.duration.setValue(this.formData?.duration || 3);
      this.forecastingService.getForecastStatus(this.formData?.code).subscribe(response => {
        let currentStatus = response['currentStatus'];
        this.predictStepIndex = (currentStatus != 'Error' ? this.statuses.indexOf(currentStatus) : 99);
        if (currentStatus === 'Completed' || currentStatus === 'Error') {
          this.loadProjectionResult()
        }
      });
    }
    const formBuilder = [];
    const L1Cat = this.categoryL1?.map(item => {
      const objItem = {
        category: item,
        marketing_spend: 0,
        macro_economic_condition: 0
      };
      return objItem;
    });

    L1Cat?.map(ifNotAvail => {
      var checkCurrentVal;
      this.formData && this.formData['categoryPrevisionList']?.map(item => {
        if (ifNotAvail.category === item.category) {
          checkCurrentVal = item.category;
          const formGroup = this.fb.group({
            category: [item.category, Validators.required],
            marketing_spend: [item.marketing_spend || 0],
            macro_economic_condition: [item.macro_economic_condition || 0],
          });
          formBuilder.push(formGroup);
        }
      });
      if (ifNotAvail.category !== checkCurrentVal) {
        const formGroup = this.fb.group({
          category: [ifNotAvail.category],
          marketing_spend: [ifNotAvail.marketing_spend || ''],
          macro_economic_condition: [ifNotAvail.macro_economic_condition || ''],
        });
        formBuilder.push(formGroup);
      }
    });
    this.categoryPrevisionList = new FormArray(formBuilder);
    this.formGroup = new FormGroup({
      name: this.name,
      active: this.active,
      categoryPrevisionList: this.categoryPrevisionList,
      overAllMarketingSpend: this.overAllMarketingSpend,
      overAllMacroEconomicCondition: this.overAllMacroEconomicCondition,
      netSales: this.net_sales,
      duration: this.duration
    });
    if (!this.formData) {
      this.createNewScenario();
    }
    this.computeFormState(this.formData);
    if (this.formData && this.formData.status && this.formData.status == "Completed" && !this.formData.active) {
      this.openPanel(2);
    }
  }
  focusNameElement() {
    this.inputField.nativeElement.focus();
  }
  getAnalyticsType() {
    const settings = this.settingService?.getSettings();
    return settings?.forecast?.analytics_type || null;
  }
  createNewScenario() {
    this.name.setValue('');
    this.overAllMarketingSpend.setValue(0);
    this.overAllMacroEconomicCondition.setValue(0);
    this.net_sales?.setValue(this.formData?.netSales || false);
    this.duration.setValue(3);
    this.categoryPrevisionList.controls.forEach(control => {
      control.get('marketing_spend').setValue('');
      control.get('macro_economic_condition').setValue('');
    });
    this.active.setValue(this.formData?.active || false);
    this.isCreateNewScenario = true;
    this.scenarioDate = null;
    this.editScenario();
  }
  ngAfterViewInit() {
    if (this.isCreateNewScenario) {
      this.inputField.nativeElement.focus();
    }
  }
  editScenario() {
    this.isEditable = !this.isEditable;
    if (this.isEditable) {
      this.formGroup.get('duration').enable();
      // this.overAllMacroEconomicCondition.enable();
      this.net_sales.enable();
    } else {
      this.formGroup.get('duration').disable();
      // this.overAllMacroEconomicCondition.disable();
      this.net_sales.disable();
    }
  }
  handlePOPUP(event) {
    let header = event.header;
    let fieldData = event.fieldData;
    this.dataEmitForPOPUPOUTER.emit({ header, fieldData });
  }
  ngOnDestroy(): void {
    clearInterval(this.intervalId);
    delete this.dynamicHeaders;
    delete this.gridData;
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  computeFormState(formData) {
    if (formData == null) {
      //New Scenario
      this.canApprove = false;
      this.canPredict = false;
      this.formGroup.get('active').disable();
      this.forecastStepState = [false, false, false];
      return;
    }
    if (formData.demandConversionDate) {
      // Converted scenario should not be editable
      this.canApprove = false;
      this.canPredict = false;
      this.formGroup.get('active').disable();
      this.forecastStepState = [true, true, true];
      return;
    }

    if (!formData.active) {
      this.canPredict = true;
    } else {
      this.canPredict = false;
    }

    if ((formData.status && formData.status == "Completed")) {
      this.canApprove = true;
      this.formGroup.get('active').enable();
    } else {
      this.canApprove = false;
      this.formGroup.get('active').disable();
    }

    if (formData.status == "Error") {
      //Error in Predict step 
      this.forecastStepState = [true, false, false];
    } else if (formData.status == "Completed" && !formData.active) {
      //Awaiting approval 
      this.forecastStepState = [true, true, false];
    } else if (formData.active) {
      //All steps completed
      this.forecastStepState = [true, true, true];
    } else {
      this.forecastStepState = [true, false, false];
    }
  }

  save() {
    let categoryPrevisionList: any
    categoryPrevisionList = this.categoryPrevisionList.value.filter(item => {

      const marketingSpendVal = +item.marketing_spend > 0;
      const macroEconomicVal = +item.macro_economic_condition > 0;
      return marketingSpendVal || macroEconomicVal ;
    });
    if (this.isCreateNewScenario) {
      this.forecastingService.createForecastScenario({ ...this.formGroup.value, categoryPrevisionList: categoryPrevisionList }).subscribe(res => {
        const msg = `Created Successfully`;
        this.scenarioUpdated.emit(res['code']);
        this.formData = res;
        this.isEditable = false;
        this.snack.open(msg, "close", {
          duration: 4000,
          horizontalPosition: "center",
          verticalPosition: "top",
        });
        this.computeFormState(this.formData);
      }, (error) => {
        const msg = `Failed to create scenario, please try again later`;
        this.snack.open(msg, "close", {
          duration: 4000,
          horizontalPosition: "center",
          verticalPosition: "top",
        });
      });
      this.isCreateNewScenario = false;
    } else {
      this.isCreateNewScenario = false;
      this.forecastingService.updateForecastScenario({ ...this.formData, ...{ ...this.formGroup.value, categoryPrevisionList: categoryPrevisionList } }).subscribe(res => {
        const msg = `Updated Successfully`;
        this.scenarioUpdated.emit(res['code']);
        this.computeFormState(res);
        this.isEditable = false;
        this.snack.open(msg, "close", {
          duration: 4000,
          horizontalPosition: "center",
          verticalPosition: "top",
        });
      });
    }
  }
  delete(event: any, code: string) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      data: {
        itemName: this.formData.name,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.deleteForecast(code);
      }
    });
  }
  deleteForecast(code: any) {
    if (this.formData && this.formData.code) {
      this.forecastingService.deleteForecastScenario(code).subscribe(
        () => {
          const msg = `Deleted Successfully`;
          this.snack.open(msg, "close", {
            duration: 4000,
            horizontalPosition: "center",
            verticalPosition: "top",
          });
          this.scenarioUpdated.emit("");
        },
        (error) => {
          const msg = `Failed to delete scenario, please try again later`;
          this.snack.open(msg, "close", {
            duration: 4000,
            horizontalPosition: "center",
            verticalPosition: "top",
          });
        }
      );
    }
  }
  openPanel(index: number) {
    this.panelOpenState = this.panelOpenState.map((_, i) => i === index);
  }
  generateForecast() {
    this.showLastStep = false;
    this.canPredict = false;
    this.forecastingService.generateWoodenStreetForecast(this.formData.code).subscribe(response => {
      this.predictStepIndex = 0;
      this.gridData = [];
      this.pollStatus(10000);
    })
  }
  pollStatus(pollPeriod: number = 10000): void {
    this.subscription = interval(pollPeriod).pipe(
      switchMap(() => this.forecastingService.getForecastStatus(this.formData?.code)),
      takeWhile((response, index) => (response['currentStatus'] !== 'Completed' && response['currentStatus'] !== 'Error' && index < 10), true) // Include the last emitted value
    ).subscribe(response => {
      console.log(" Inside Poll status " + response['currentStatus']);
      let currentStatus = response['currentStatus'];
      this.predictStepIndex = (currentStatus != 'Error' ? this.statuses.indexOf(currentStatus) : 99);
      if (currentStatus === 'Completed' || currentStatus === 'Error') {
        this.openPanel(2);
        this.loadProjectionResult();
        this.canPredict = true;
        this.canApprove = true;
        this.forecastStepState = [true, true, false];
      }
    });
  }
  deriveMonths(startMonth: string, duration: number): string[] {
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const startDate = new Date(startMonth);
    const derivedMonths = [];
    for (let i = 0; i < duration; i++) {
      const monthIndex = (startDate.getMonth() + i) % 12;
      derivedMonths.push(months[monthIndex]);
    }
    return derivedMonths;
  }
  loadFilters(): void {
    this.filterBayService.getFilters().subscribe((response: any) => {
      const categoryLevel1Filter = response.filterDataList.find(filter => filter.code === 'category_level1');
      if (categoryLevel1Filter) {
        this.categoryLevel1Values = categoryLevel1Filter.values;
      }
    });
  }
  loadLineGraphData(code: string, filter: string): void {
    this.forecastingService.getLineGraph(code, filter).subscribe((response: any) => {
      this.lineChartData = response
      const ctx = document.getElementById('myChart') as HTMLCanvasElement;
      if (ctx) {
        const chartContext = ctx.getContext('2d');
        if (chartContext) {
          const chartData = {
            type: response?.type,
            data: {
              labels: response?.data.labels,
              datasets: response?.data.datasets.map(dataset => ({
                ...dataset,
                borderColor: dataset.borderColor[0],
                backgroundColor: dataset.backgroundColor[0],
                pointBackgroundColor: dataset.pointBackgroundColor ? dataset.pointBackgroundColor[0] : null
              }))
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              scales: {
                x: {
                  type: 'category',
                  labels: response?.data.labels
                },
                y: {
                  beginAtZero: true,
                  title: {
                    display: true,
                    text: 'Quantity Sold'
                  }
                }
              }
            }
          };

          if (this.chart) {
            this.chart.destroy();
          }
          this.chart = new Chart(chartContext, chartData);
        }
      }
    }, error => {
      console.error('Error fetching line graph data:', error);
    });
  }
  loadProjectionResult(): void {
    this.displayProjectionResult = false;
    this.forecastingService.getWoodenStreetGridResults(this.formData?.code).subscribe(res => {
      const startDate = res['startMonth'];
      // this.dynamicHeaders = JSON.parse(JSON.stringify(forecastHeader));
      this.dynamicHeaders = res['headerContent'] ? JSON.parse(res['headerContent']) : null;
      // const months = this.deriveMonths(startDate, res['duration'])
      // let monthNum = 1;
      // months.map((month) => {
      //   const dynamicField = {
      //     "field": `forecast_month_${monthNum++}`,
      //     "headerText": month,
      //     "width": "120",
      //   }
      //   this.dynamicHeaders.push(dynamicField);
      // })
      this.gridData = res['items'];
      setTimeout(() => {
        this.displayProjectionResult = true;
      });
      // this.displayProjectionResult = true;
    })
    this.loadFilters();
    this.loadLineGraphData(this.formData.code, '');
  }
  formatLabel(value: number): string {
    return `${value}`;
  }
  formatDate(date: string): string {
    return this.datePipe.transform(date, 'MMMM d, yyyy');
  }
  approveForecast(event: MatSlideToggleChange) {
    this.active.setValue(event.checked);
    this.save();
  }
  getHeaderColumns(): string[] {
    const baseColumns = ['category', 'marketing_spend', 'macro_economic_condition'];
    return baseColumns;
  }
  getRowColumns(): string[] {
    return this.getHeaderColumns();
  }
  uploadFile(event) {
    if (event && event.target && event.target.files && event.target.files.length > 0) {
      this.forecastingService.uploadFile(event.target.files[0], this.authService.getUserName(), this.formData.code).subscribe((res) => {
        alert("File uploaded successfully...");
      }, (error) => {
        alert("Upload failed. Please try again");
      })
    }
  }
  toggleFilterOptions(): void {
    this.showFilterOptions = !this.showFilterOptions;
  }
  onFilterChange(value: string): void {
    this.selectedFilter = value;
    this.loadLineGraphData(this.formData.code, this.selectedFilter);
    this.showFilterOptions = false;
    // this.updateChart(this.selectedFilter);
  }
  addFormGroup() {
    this.categoryPrevisionList.push(this.createFormGroup());
  }

  removeObjects(i) {
    this.categoryPrevisionList.removeAt(i);
  }
  createFormGroup(): FormGroup {
    return new FormGroup({
      category: new FormControl('', Validators.required),
      marketing_spend: new FormControl('', [Validators.required, Validators.minLength(1)]),
      macro_economic_condition: new FormControl('', [Validators.required, Validators.minLength(1)]),
    });
  }
}
